module.exports = __webpack_public_path__ + "img/visa-card.cbba3d45.svg";